import { render } from "./FeynmanTechnique.vue?vue&type=template&id=446326a9&scoped=true"
import script from "./FeynmanTechnique.vue?vue&type=script&lang=js"
export * from "./FeynmanTechnique.vue?vue&type=script&lang=js"

import "./FeynmanTechnique.vue?vue&type=style&index=0&id=446326a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446326a9"]])

export default __exports__